import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router';

import { Box } from '@mui/system';
import { Stack, Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
import { useParams, useRouter } from 'src/routes/hooks';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

// ----------------------------------------------------------------------

export default function PlacementsPage() {
  const settings = useSettingsContext();

  const { t } = useTranslate();

  const { placement_id } = useParams();

  const router = useRouter();

  const { pathname } = useLocation();

  const viewingDetails = useMemo(() => !!placement_id, [placement_id]);

  const onBack = () => {
    router.back();
  };

  return (
    <>
      <Helmet>
        <title>Dashboard: Placements</title>
      </Helmet>

      <Container
        maxWidth={settings.themeStretch ? false : 'lg'}
        sx={{
          height: 1,
        }}
      >
        <Stack spacing={1}>
          <CustomBreadcrumbs
            heading={t(`jobs.detail.placements.title`)}
            links={[
              { name: t('common.dashboard'), href: paths.dashboard.root },
              {
                name: t(`jobs.detail.placements.title`),
                href: `${paths.dashboard.placements.root}`
              }
            ]}
          />

          {viewingDetails && (
            <Box>
              <Button
                fullWidth={false}
                component={RouterLink}
                onClick={onBack}
                startIcon={<Iconify icon="eva:arrow-ios-back-fill" width={16} />}
              >
                {t('common.back')}
              </Button>
            </Box>
          )}

          <Outlet />
        </Stack>
      </Container>
    </>
  );
}
